let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gA0kL")).then(() => parcelRequire('8bI7u'));